module.exports = {
  API_SERVER_URL: 'https://tomcom-api.alphadelivery.uk',
  GA_ID: 'GTM-KFGTTLC',
  STRIPE_PUB_KEY: 'pk_test_51LClDkLrfYfweLEzA6I6j5dr05Rnr6vQuHjKWypaQHyK6m9VKUY6Tclz3XyFe9ZPpllRKX1w1SnfHikQlUPXizZL00yyv4BcBV',
  // Custom URL scheme the mobile app registers (iOS CFBundleURLSchemes /
  // Android android:scheme) — it is the bundle id, not 'tomcom'.
  APP_SCHEME: 'com.jbi.tomcom.alpha',
  PHOTO_COST: 20,
};
